import { Box, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { useDispatchApp } from "../../../../lib/redux";
import { startSendMessageChatBot } from "../../../../actions/chat";
import {
  ADS_CAMPAIGN_STATISTICS_SLIDE_MENU_OVERVIEW,
  OVERVIEW_REPORT_GENERATING_SUMMARY,
  OVERVIEW_REPORT_SUMMARY_NOT_GENERATED,
} from "../../../../i18n/keysTranslations";
import { useTranslationApp } from "../../../../lib/i18next";
import {
  AUTOMATIC_AGENT_REQUEST_KINDS,
  BORDER_RADIUS,
} from "../../../../utils/constants";
import {
  getFormattedCampaign,
  getLanguageFormatted,
} from "../../../../utils/string";
import { useFormContext } from "react-hook-form";
import { getFromStatisticsAdsCampaign } from "../../../../services/adsCampaigns";
import { BOX_SHADOW_THEME, INPUT_COLOR_BORDER } from "../../../../utils/colors";
import i18next from "i18next";
import { useReportSnapshot } from "../../../../features/reportPdf/ReportSnapshotContext";

import { LaunchError } from "../../../../utils/errors";

const SummaryTetx = ({
  onSummaryGenerated = () => {},
  onSummaryFetchSettled = () => {},
}) => {
  const reportSnapshot = useReportSnapshot();
  const { campaign, reportConfiguration } = useFormContext();
  const { historical } = getFromStatisticsAdsCampaign(campaign);
  const { t } = useTranslationApp();
  const dispatch = useDispatchApp();
  const [generatedText, setGeneratedText] = useState(
    reportSnapshot?.summaryText || ""
  );
  const [isLoading, setIsLoading] = useState(false);

  const onGenerateSummaryText = async () => {
    setIsLoading(true);
    try {
      const language = getLanguageFormatted(i18next.language);

      const response = await dispatch(
        startSendMessageChatBot({
          chatContext: {
            campaign: getFormattedCampaign({
              data: {
                ...(campaign || {}),
                historicalStatistics: {
                  ...(campaign?.historicalStatistics || {}),
                  historical: historical,
                },
              },
              format: "save",
            }),
            reportConfiguration: {
              startDateTime: reportConfiguration.startDateTime,
              endDateTime: reportConfiguration.endDateTime,
              language,
            },
          },
          // Passive panel: server owns the prompt for this kind and does not bill it.
          automaticRequest: {
            kind: AUTOMATIC_AGENT_REQUEST_KINDS.CAMPAIGN_REPORT_SUMMARY,
            language,
          },
        })
      );

      if (response && response?.data?.[0]?.answer) {
        setGeneratedText(response.data[0].answer);
        onSummaryGenerated(response.data[0].answer);
      }
    } catch (error) {
      dispatch(
        LaunchError(error, false, [], {
          functionName: "onGenerateSummaryText",
          capture: "exception",
        })
      );
      console.error("Error generando texto del resumen:", error);
    } finally {
      setIsLoading(false);
      onSummaryFetchSettled();
    }
  };

  useEffect(() => {
    if (reportSnapshot) {
      const text = reportSnapshot.summaryText || "";
      setGeneratedText(text);
      onSummaryGenerated(text);
      onSummaryFetchSettled();
      return;
    }
    onGenerateSummaryText();
    // eslint-disable-next-line
  }, []);

  return (
    <Box
      id="summary-section"
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        width: "100%",
        gap: 3,
        height: "100%",
        pt: 3,
      }}
    >
      <Typography
        variant="h5"
        sx={{
          fontWeight: 600,
        }}
      >
        {t(ADS_CAMPAIGN_STATISTICS_SLIDE_MENU_OVERVIEW)}
      </Typography>

      <Box
        data-pdf-card
        sx={{
          backgroundColor: "fields.background",
          border: `1px solid ${INPUT_COLOR_BORDER}`,
          boxShadow: BOX_SHADOW_THEME,
          borderRadius: BORDER_RADIUS,
          p: 2,
          minHeight: 120,
        }}
      >
        {isLoading ? (
          <Typography variant="body2" color="text.secondary">
            {t(OVERVIEW_REPORT_GENERATING_SUMMARY)}
          </Typography>
        ) : generatedText ? (
          <Typography variant="body1" sx={{ lineHeight: 1.6 }}>
            {generatedText}
          </Typography>
        ) : (
          <Typography variant="body2" color="text.secondary">
            {t(OVERVIEW_REPORT_SUMMARY_NOT_GENERATED)}
          </Typography>
        )}
      </Box>
    </Box>
  );
};

export default SummaryTetx;
